<mat-card class="mat-elevation-z0">
    <mat-card-title><strong>Enter a name to save the filter</strong></mat-card-title>
    <mat-card-content>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <input matInput placeholder="Filter name" [formControl]="filterNameCtrl">
        </mat-form-field>
    </mat-card-content>
    <mat-card-actions>
        <button mat-raised-button type="button" (click)="cancel()">Cancel</button>
        <button mat-raised-button type="button" color="primary" (click)="submit()">Ok</button>
    </mat-card-actions>
</mat-card>